import type { UrlEntry, UrlRegion } from '@/types';

export const urls: Record<'contact', Record<UrlRegion, UrlEntry>> = {
  contact: {
    de: 'kontakt',
    'de-en': 'contact',
    es: 'contacto',
    'es-en': 'contact',
    fr: 'contact',
    'fr-en': 'contact',
    gb: 'contact',
    nl: 'contact',
    'nl-en': 'contact',
    pt: 'contacto',
    'pt-en': 'contact',
    us: 'contact',
    ww: 'contact',
  },
};
